/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import moment from 'moment';
import {SET_SIDE_FILTER_LIST, SET_AUDIT_DIALOG_SHOW, SET_AUDIT_DIALOG_DATA} from "../../mutation-types";

const state = {
  audit: {},
  error: null,
  showFilters: false,
  sideFilterList: {},
  activeFilters: [],
  auditDialogShow: false,
  auditDialogData: {
    id: null,
    event: null,
    changes: {
      attributes: null,
      old: null,
    },
    subject: {},
    subject_type: null,
    causer_type: null,
    causer: {},
    created_at: null,
  },
  eventTypeFilters: [],
  modelTypeFilters: [],
  isFetchDataNeeded: false,
};

const getters = {
  audit: state => state.audit,
  error: state => state.error,
  showFilters: state => state.showFilters,
  sideFilterList: state => state.sideFilterList,
  activeFilters: state => state.activeFilters,
  filtersType1: state => state.filtersType1,
  filtersType2: state => state.filtersType2,
  auditDialogShow: state => state.auditDialogShow,
  auditDialogData: state => state.auditDialogData,
  eventTypeFilters: state => state.eventTypeFilters,
  modelTypeFilters: state => state.modelTypeFilters,
  isFetchDataNeeded: state => state.isFetchDataNeeded,
};

const actions = {
  oldFetch({ commit }, payload) {
    let path = '';
    if (payload.user.data.selectedRole &&
      payload.user.data.selectedRole.role === 'landlord' &&
      !payload.user.data.selectedRole.isSuperadmin) {
      path = `landlords/${payload.user.data.selectedRole.id}`;
    } else {
      path = `superadmin/${payload.user.data.id}`;
    }
    return Vue.http.get(
      `${process.env.BACKEND_API_URL}api/${path}/audit/list` +
      `?q=${payload.options.q}` +
      `&limit=${payload.options.limit}` +
      `&ascending=${payload.options.ascending}` +
      `&page=${payload.options.page}` +
      `&byColumn=${payload.options.byColumn}` +
      `&orderBy=${payload.options.orderBy}` +
      `&date_from=${payload.options.dateFrom}` +
      `&date_to=${payload.options.dateTo}` +
      `&isHideGuestParking=${payload.options.isHideGuestParking}`,
    ).then((response) => {
      commit(mTypes.DATA_FETCHED, response);
    });
  },
  fetch({ commit }, payload) {
    let id = '';
    if (payload.user.data.selectedRole &&
    payload.user.data.selectedRole.role === 'landlord' ||
    payload.user.data.selectedRole.isSuperadmin) {
      id = payload.user.data.selectedRole.id;
    }

    const modelTypeParams = new URLSearchParams();
    payload.options.modelType.map(value => modelTypeParams.append('model_types[]', value));

    const eventTypeParams = new URLSearchParams();
    payload.options.eventType.map(value => eventTypeParams.append('event_types[]', value));

    return Vue.http.get(
      `${process.env.BACKEND_API_URL}api/v2/${id}/audit` +
      `?q=${payload.options.q}` +
      `&limit=${payload.options.limit}` +
      `&ascending=${payload.options.ascending}` +
      `&page=${payload.options.page}` +
      `&byColumn=${payload.options.byColumn}` +
      `&orderBy=${payload.options.orderBy}` +
      `&date_from=${payload.options.dateFrom}` +
      `&date_to=${payload.options.dateTo}` +
      `&hide_guest_parkings=${payload.options.isHideGuestParking}` +
      `&${modelTypeParams}` +
      `&${eventTypeParams}` +
      `&query_type=${payload.options.queryType ? payload.options.queryType : ''}`
    ).then((response) => {
      commit(mTypes.DATA_FETCHED, response);
    });
  },
  setShowFilters({ commit }, payload) {
    commit(mTypes.SET_SHOW_FILTERS, payload);
  },
  setSideFilterList({ commit }, payload) {
    commit(mTypes.SET_SIDE_FILTER_LIST, payload);
  },
  setActiveFilters({ commit }, payload) {
    commit(mTypes.SET_ACTIVE_FILTERS, payload);
  },
  setAuditDialogShow({ commit }, payload) {
    commit(mTypes.SET_AUDIT_DIALOG_SHOW, payload);
  },
  setAuditDialogData({ commit }, payload) {
    const formatTimeStrings = data => Object.entries(data).map(
      ([k, v]) => {
        if ((k === 'valid_from_date' && v) || (k === 'expiration_date' && v)) {
          return [k, moment(v).format('DD.MM.YYYY')];
        }

        return [k, v];
      },
    );

    payload.changes.attributes = Object.fromEntries(formatTimeStrings(payload.changes.attributes)) 
    payload.changes.old = Object.fromEntries(formatTimeStrings(payload.changes.old)) 

    commit(mTypes.SET_AUDIT_DIALOG_DATA, payload);
  },
  setEventTypeFilter({ commit }, payload) {
    commit('set_event_type_filter', payload);
  },
  setModelTypeFilter({ commit }, payload) {
    commit('set_model_type_filter', payload);
  },
  setIsFetchDataNeeded({ commit }, payload) {
    commit('set_is_fetch_data_needed', payload);
  }
};

const mutations = {
  ['set_is_fetch_data_needed'](state, payload) {
    state.isFetchDataNeeded = payload;
  },
  ['set_event_type_filter'](state, payload) {
    state.eventTypeFilters = payload;
  },
  ['set_model_type_filter'](state, payload) {
    state.modelTypeFilters = payload;
  },
  [mTypes.DATA_FETCHED](state, audit) {
    state.audit = audit.data;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error === null ? error : error.data.message;
  },
  [mTypes.SET_SHOW_FILTERS](state, showFilters) {
    state.showFilters = showFilters;
  },
  [mTypes.SET_SIDE_FILTER_LIST](state, sideFilters) {
    state.sideFilters = sideFilters;
  },
  [mTypes.SET_ACTIVE_FILTERS](state, activeFilters) {
    state.activeFilters = activeFilters;
  },
  [mTypes.SET_AUDIT_DIALOG_SHOW](state, status) {
    state.auditDialogShow = status;
  },
  [mTypes.SET_AUDIT_DIALOG_DATA](state, data) {
    state.auditDialogData = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/audit/audit.js